import React, { useState, useEffect, useContext } from 'react';
// import PropTypes from "prop-types";
import cn from 'classnames';
import { withStyles } from '@material-ui/styles';
import { DynamicFormModal, DynamicForm } from '../../DynamicForm';
import * as v from '../../../helpers/validation';
import { OrderDetailContext } from '../OrderDetailContext';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

// SERVICES
import { getOrderSpecialInstructions, updateSpecialInstructions } from '../../../services';
import SectionHeader from '../../ReactHookForm/SectionHeader';
import { useHistory } from 'react-router';
import FormInput from '../../ReactHookForm/FormInput/FormInput';
import { Button, CircularProgress, Grid } from '@material-ui/core';
import { AppContext } from '../../../AppContext';

const FORM_FIELDS = {
  ORDER_LINE_ID: 'orderLineId',
  SPECIAL_INSTRUCTIONS: 'specialInstructions',
};

const formValidationSchema = Yup.object().shape({
  [FORM_FIELDS.ORDER_LINE_ID]: Yup.string()
    .default('')
    .required('Orderline ID cannot be empty'),

  [FORM_FIELDS.SPECIAL_INSTRUCTIONS]: Yup.string().default(''),
});

const styles = theme => ({
  actionButton: {
    color: 'white',
    marginTop: 20,
  },

  actionButton: {
    backgroundColor: 'var(--jmi-blue)',
  },

  form: {
    width: '100%',
  },
});

export const OrderDetailInstructionsTab = withStyles(styles)(({ orderLineId, classes }) => {
  const { state, dispatch } = useContext(OrderDetailContext);
  const { dispatch: appDispatch } = useContext(AppContext);
  const history = useHistory();

  const formMethods = useForm({
    resolver: yupResolver(formValidationSchema),
    reValidateMode: 'onSubmit',
  });

  const onSubmitInvalid = async errors => {
    console.log('invalid', errors);
  };
  const onSubmitValid = async form => {
    try {
      await updateSpecialInstructions(form);

      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          message: 'Instructions saved',
          variant: 'success',
        },
      });
    } catch (error) {
      console.log(error, error.message);

      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          message: `Something went wrong.  Check the log for details`,
          variant: 'error',
        },
      });
    }
  };

  useEffect(() => {
    // get special instructions
    (async () => {
      try {
        const data = await getOrderSpecialInstructions(orderLineId);

        formMethods.reset(data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  return (
    <>
      <FormProvider {...formMethods} schema={formValidationSchema}>
        <form onSubmit={formMethods.handleSubmit(onSubmitValid, onSubmitInvalid)} className={classes.form}>
          <SectionHeader title="Details" />

          <Grid item xs={6}>
            <FormInput
              //
              type="text"
              name={FORM_FIELDS.ORDER_LINE_ID}
              label="Orderline ID"
              inputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs={6}></Grid>

          <Grid item xs={6}>
            <FormInput
              //
              type="textarea"
              name={FORM_FIELDS.SPECIAL_INSTRUCTIONS}
              label="Special Instructions"
              inputProps={{
                rows: 20,
                style: { height: 'auto', width: '100%' },
              }}
            />
          </Grid>
          <Grid item xs={6}></Grid>

          <Grid item xs={12} container style={{ marginTop: 50 }}>
            <Button style={{ backgroundColor: '#315382', color: '#fff' }} variant="contained" type="submit">
              {formMethods.formState.isSubmitting ? (
                <>
                  <CircularProgress style={{ fill: '#fff', color: '#fff', marginRight: 10 }} size={25} />
                  Saving
                </>
              ) : (
                'Save Instructions'
              )}
            </Button>
          </Grid>
        </form>
      </FormProvider>
    </>
  );
});

OrderDetailInstructionsTab.propTypes = {};

OrderDetailInstructionsTab.defaultProps = {};
